import { gsap } from 'gsap';
function Animate(
  sprite,
  {
    duration = 0.5,
    speed = 1,
    ease = 'Cubic.easeIn',
    canvasHeight,
    canvasWidth,
    index,
    totalLines,
    isBackground,
    isMask,
    Textsprite,
    SubSceneContainer,
    isTemplate,
  }
) {
  if (!isBackground) {
    var finalAlpha = sprite.alpha;
    sprite.alpha = 0;
    var y = sprite.y;
    sprite.y = sprite.y + 20;
    let delay = 0;
    if (isTemplate && index) {
      delay = index * (duration * speed);
    }
    var animation = gsap.to(sprite, {
      pixi: { y: y, alpha: finalAlpha },
      duration: duration * speed,
      ease: 'slow(0.3, 0.7, false)',
      delay: delay,
      paused: true,
    });
    return animation;
  } else {
    if (isMask) {
      SubSceneContainer.addChild(sprite);
      Textsprite.mask = sprite;
    }
    var spriteWidht = sprite.width;
    var x = sprite.x;
    sprite.width = 0;
    //sprite.x = canvasWidth / 2;
    sprite.x = x + spriteWidht;
    let delay = 0;
    if (isTemplate) {
      delay = index * (duration * speed);
    }
    var animation = gsap.to(sprite, {
      pixi: { x: x, width: spriteWidht },
      duration: speed,
      ease: 'slow(0.7, 0.7, false)',
      delay: delay,
      paused: true,
    });
    return animation;
  }
}
export default { Animate };
